import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#09A34A'
    },
    secondary: {
      main: '#090977',
      minor: '#2C6BB2'
    },
    tertiary: {
      main: '#FEDF46'
    },
    danger: {
      main: 'red',
      minor: '#f05757'
    },
    buttonWhite: {
      default: '#ffffff'
    },
    highlight: {
      light: '#efa449',
      main: '#f19322',
      dark: '#f08708',
      contrastText: '#fff',
      highlight: '#FF9933'
    },
    subTitle: {
      main: '#666666'
    },
    error: {
      main: red.A400
    },
    lightGrey: {
      default: '#e6e6e6'
    },
    borderGray: {
      default: '#7E7E7E'
    },
    separator: '#D8D8D8',
    dashboardDark: {
      main: '#272F44',
      minor: '#0A1B2B'
    }
  }
});

export default theme;
